import { connect, useDispatch } from 'react-redux';

import { isFilesSizeValid } from 'CorePackage/MainModule/common/isFilesSizeValid';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IUploadFile } from 'CorePackage/MainModule/interfaces/IUploadFile';
import { feedbackSetFiles } from 'FeedbackPackage/MainModule/actions/feedbackActions';
import { getFeedbackFiles } from 'FeedbackPackage/MainModule/reducers/feedbackReducer';

import { UploadStatusView } from './UploadStatusView';

export interface IUploadStatusProps {
  files: IUploadFile[];
  setError: (error: string) => void;
}

const UploadStatusContainer = ({ files, setError }: IUploadStatusProps) => {
  const dispatch = useDispatch();
  const onRemove = (fileName: string) => {
    if (isFilesSizeValid(files.filter(el => el.fileName !== fileName))) {
      setError('');
    }
    dispatch(feedbackSetFiles(files.filter(item => item.fileName !== fileName)));
  };

  if (!(files.length > 0)) {
    return null;
  }

  return (
    <>
      {files.map(fileInfo => (
        <UploadStatusView
          key={fileInfo.fileName}
          fileName={fileInfo.fileName}
          fileSize={fileInfo.fileSize}
          fileType={fileInfo.fileType}
          progress={fileInfo.progress}
          onRemove={onRemove}
          error={fileInfo.error}
        />
      ))}
    </>
  );
};

const mapStateToProps = (state: IRootState) => ({
  files: getFeedbackFiles(state),
});

export const UploadStatus = connect(mapStateToProps)(UploadStatusContainer);
